@if (model()) {
<div class="cast">
    <app-select [formGroup]="formGroup()!" [meta]="metaCast" [model]="model().cast" (change)="onCast($event)"></app-select>
    <app-json [formGroup]="formResult" [meta]="metaResult" [model]="model().jsonImport" (update)="onJson($event)"></app-json>
</div>
}
